import { PerpTradeConfirmationModal } from './PerpTradeConfirmationModal';
import { SpotTradeConfirmationModal } from './SpotTradeConfirmationModal';
import { TradeConfirmationModalProps } from 'src/components/TradeConfirmationModal/types';

export const TradeConfirmationModal = ({
	tradeFormDetails,
}: TradeConfirmationModalProps) => {
	if (!tradeFormDetails) return null;

	return tradeFormDetails.market.isPerp ? (
		<PerpTradeConfirmationModal tradeFormDetails={tradeFormDetails} />
	) : (
		<SpotTradeConfirmationModal tradeFormDetails={tradeFormDetails} />
	);
};
